import type { PointerEvent as ReactPointerEvent } from 'react'
import {
  FROZEN_OBJECT_CURSOR,
  HANDLE_BORDER_WIDTH,
  HANDLE_SIZE,
  ROTATE_CURSOR,
} from '@/components/app/editor/selection-chrome/selection-chrome-constants'
import { ROTATE_HANDLE_CENTER_OFFSET } from '@/lib/editor/constants/rotate-handle-center-offset'
import type { SelectionChromePreview } from '@/lib/shapes/selection-chrome-preview'

import { HANDLE_HIT_PX } from '../constants/chrome-hit-sizes'
import { resolveDecorationOpacity } from '../helpers/chrome-appearance'

/** The rotation stem, its hit circle (interactive only) and the visible knob at its end. */
export function ChromeRotationKnob({
  geometry,
  strokeColor,
  geometryInactive,
  interactive,
  beginRotate,
}: {
  geometry: SelectionChromePreview
  strokeColor: string
  geometryInactive: boolean
  interactive: boolean
  beginRotate: (event: ReactPointerEvent<SVGElement>) => void
}) {
  const stemEnd = {
    x: geometry.rotationAnchor.x + geometry.rotationDirection.x * ROTATE_HANDLE_CENTER_OFFSET,
    y: geometry.rotationAnchor.y + geometry.rotationDirection.y * ROTATE_HANDLE_CENTER_OFFSET,
  }

  return (
    <>
      <line
        x1={geometry.rotationAnchor.x}
        y1={geometry.rotationAnchor.y}
        x2={stemEnd.x}
        y2={stemEnd.y}
        stroke={strokeColor}
        strokeWidth={HANDLE_BORDER_WIDTH}
        opacity={resolveDecorationOpacity(geometryInactive)}
        style={{ pointerEvents: 'none' }}
      />
      {/* Hit circle only — the visible stem and knob below stay, so a non-interactive chrome
          still looks identical. */}
      {interactive && (
        <circle
          cx={stemEnd.x}
          cy={stemEnd.y}
          r={HANDLE_HIT_PX / 2}
          fill="transparent"
          style={{
            pointerEvents: 'all',
            cursor: geometryInactive ? FROZEN_OBJECT_CURSOR : ROTATE_CURSOR,
          }}
          onPointerDown={beginRotate}
        />
      )}
      <circle
        cx={stemEnd.x}
        cy={stemEnd.y}
        r={HANDLE_SIZE / 2}
        fill="var(--color-card, #fff)"
        stroke={strokeColor}
        strokeWidth={HANDLE_BORDER_WIDTH}
        opacity={resolveDecorationOpacity(geometryInactive)}
        style={{ pointerEvents: 'none' }}
      />
    </>
  )
}
